import {useQuery} from "react-query";
import DictionariesApiClient from "api/DictionariesApiClient";

export function useSportTypes(options) {
    return useQuery(
        ["sportTypes"],
        () => DictionariesApiClient.getSportTypes(),
        options,
    );
}